export { default } from './CommentInfo';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/CommentInfo/index.js